<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: "app",
    created() {
      const path = this.$route.path;
      if (path.indexOf('//') > -1) { // 处理微信扫码跳转
        this.$router.replace({
          path: path.replace('//', '/'),
          query: this.$route.query
        });
      }
      this.$store.commit("setFontSize");
      window.onresize = () => {
        this.$store.commit("setFontSize");
      };
    }
  };
</script>

<style lang="less">
  @import url('./assets/less/theme.less');

  #app {
    background: linear-gradient(180deg, #E7F1F8 0%, #FAFBFD 100%);
  }

  li::marker {
    content: '';
  }

  a {
    text-decoration: none;
    cursor: pointer;
  }

  html, body, #app {
    font-family: PingFangSC-Regular PingFang SC, 'Microsoft Yahei', '微软雅黑', Sans-serif;
    height: 100%;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all .2s ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  /* 覆盖element样式 */
  .com-input {
    height: 40px;

    .el-input__inner {
      height: 100%;
    }

    .el-icon-search {
      font-size: 26px;
    }
  }

  .el-dropdown-menu__item {
    font-size: 12px;
  }

  .el-input .el-input__inner {
    padding-left: 1.8rem;
  }

  .el-select, .el-cascader {
    width: 100%;
  }

  .el-select.my-select {
    height: 40px;
    border-radius: 4px;
    border: 1px solid #555555;

    .el-input {
      height: 100%;
    }

    .el-input__inner {
      border: none;
      height: 100%;
    }
  }

  .el-upload {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-input__icon + .el-input__inner, .el-cascader__label {
    padding-left: 1.8rem;
  }

  .el-dialog {
    width: auto;
  }

  @color-search: #1890FF;
  .search-box {
    border-radius: 4px;
    border: 2px solid @color-search;
    height: 36px;

    .el-input-group__append, .el-input-group__prepend, .el-input__inner {
      background: transparent;
      border: none;
      border-radius: 0;
    }

    .el-icon-search {
      font-size: 20px;
      color: @color-search;
    }

    .el-input-group__append {
      width: 128px;
      background: @color-search;
      color: #fff;
      text-align: center;

      &:hover {
        background: #068AFF;
      }
    }
  }

  .el-textarea {

    &, .el-textarea__inner {
      height: 100%;
    }

    .el-textarea__inner {
      padding-left: 1.8rem;
    }
  }

  .el-button--primary {
    background-color: @color-primary;
    border-color: @color-primary;
  }

  .ac-tabs {
    .el-tabs__header {
      margin-bottom: 0;
      border-bottom: none;
    }

    .el-tabs__item {
      text-align: center;
      box-sizing: content-box;
    }
  }

  .el-pagination {
    text-align: center;

    .el-pager li, button, span, .el-select .el-input input, .el-pagination__editor {
      min-width: 32px !important;
      height: 32px !important;
      line-height: 32px !important;
      box-sizing: border-box;
    }

    .el-pager li.active {
      border-color: @color-primary;
      background-color: @color-primary;
    }
  }

  .top-bar {
    .el-breadcrumb {
      font-size: 16px;

      .el-breadcrumb__item__inner, .el-breadcrumb__item__inner a {
        color: #999999;
      }

      .el-breadcrumb__item:last-child .el-breadcrumb__item__inner {
        color: #333333;
      }
    }
  }

  .upload-video {
    width: 400px;

    .el-upload {
      display: block;
    }

    .el-upload-dragger {
      width: 100%;
      height: 200px;
      background: #FBFBFB;
      border-radius: 4px;
      border: 2px solid #8BC4FF;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        width: 40px;
        height: 40px;
        margin-bottom: 23px
      }
    }

    .el-upload__text {
      .bigger {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        margin-bottom: 8px;
      }

      .detail {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
      }
    }
  }

  .img-list {
    .el-upload {
      width: 148px;
      height: 148px;
      display: inline-block;
    }
  }

  .el-table .cell {
    display: flex;
    align-items: center;
    padding: 10px 18px;

    .el-button {
      width: 87px;
      height: 40px;
      line-height: 40px;
      padding: 0;
    }
  }

  .query-time.el-input {
    width: 170px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #555555;

    .el-input__inner {
      height: 100%;
      border: none;
      font-size: 16px;
      color: #333;
    }
  }

  .el-table__footer-wrapper thead div, .el-table__header-wrapper thead div {
    background: #C3E0FF;
    color: #057CF9;
  }

  .el-table__column-filter-trigger i {
    color: #057CF9;
  }

  .el-table__column-filter-trigger {
    line-height: 30px;
  }

  .el-carousel__item {
    display: flex;
    align-items: center;
    justify-content: center
  }
</style>



// WEBPACK FOOTER //
// App.vue?4141cb8a